<div class="wrapper page-heading page-heading-header-bg">
    <div class="row page-heading-left">
        <div class="col-xs-6">
            <h1 [i18n]="'df-management.df-admin.title'" (click)="goBackAdmin()"></h1>
        </div>
    </div>
</div>

<section class="container">
    <div class="wrapper country-heading ">
        <div class="row page-heading-left">
            <div class="col-xs-6 col-sm-7">
                <h1 class="table-heading" [i18n]="'df-management.df-admin.heading.title'"></h1>
            </div>
            <div class="col-xs-6 ">
                <div class="row">
                    <div class="col-xs-6 pull-right">
                        <input class="form-control input-style" [(ngModel)]="searchText"
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.heading.search-placeholder'}]">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<br>
<div class="container summary-panel">
        <div class="ibox float-e-margins">
            <div class="ibox-content no-padding">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th  [i18n]="'df-management.df-admin.table.country-name'"></th>
                            <th  [i18n]="'df-management.df-admin.table.country-code'"></th>
                            <th  [i18n]="'df-management.df-admin.table.time-zone'"></th>
                            <th  [i18n]="'df-management.df-admin.table.fixed-charge-frequency'"></th>
                            <th  [i18n]="'df-management.df-admin.table.variable-charges'"></th>
                            <th  [i18n]="'df-management.df-admin.table.actions'"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let r of countryList | filter: searchText">
                            <td class="tableContent">{{r.country}}</td>
                            <td class="tableContent">{{r.country_code}}</td>
                            <td class="tableContent">{{r.timezone}}</td>
                            <td class="tableContent">{{r.country_job_frequency_details.fixed_charge_frequency || '-'}}</td>
                            <td class="tableContent">
                                {{ r.variable_charge_flag ? 'Submitted' : 'Not Submitted' }}
                                <i *ngIf="r.variable_charge_flag" class="fa fa-info-circle tooltip-icon" data-toggle="tooltip" data-placement="top" [title]="getVariableChargesList(r)"></i>
                              </td>
                            <td>
                                <div class="chepfm-table__actions" >
                                    <button type="button" class="btn btn-info btn-sm" (click)="onEditEvent(r)">
                                        <i class="fa fa-caret-right vert-align-top" aria-hidden="true"></i></button>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="!countryList || countryList.length === 0">
                            <td [attr.colspan]="6" class="force-text-center"><em [i18n]="'df-management.df-admin.table.no-charges-yet'"></em></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
</div>

<div class="overlay-form" *ngIf="isVisible">
    <div class="chepfm--form__collapse-wrapper"
        [ngClass]="isVisible ? 'chepfm--form__collapse-show' : 'chepfm--form__collapse-hide'">
        <div class="chepfm--form__collapse-header">
            <h6 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.heading.title'"></h6>
            <div class="close-icon">
                <button type="button" class="btn btn-link" (click)="onCloseEvent()">
                    <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                </button>
            </div>
        </div>
        <div class="chepfm--form__collapse-contain">
            <form class="chepfm--form" [formGroup]="variableChargesDataForm">
                <div class="row">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label [i18n]="'df-management.df-admin.table.country-code'"></label>
                            <input type="text" class="form-control" [attr.disabled]="true" formControlName="countryCode"
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.table.country-code'}]" readonly>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label [i18n]="'df-management.df-admin.table.country-name'"></label>
                            <input type="text" class="form-control" [attr.disabled]="true" formControlName="countryName"
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.table.country-name'}]" readonly>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label [i18n]="'df-management.df-admin.table.time-zone'"></label>
                            <input type="text" class="form-control" [attr.disabled]="true" formControlName="timezone"
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.table.time-zone'}]" readonly>
                        </div>
                    </div>
                </div>

                <h5 class="chepfm--form__collapse-heading" [i18n]="'df-management.form.name.charge-type'"></h5>
                <hr />
                    <h4 class="chepfm--form__collapse-heading"  [i18n]="'df-management.df-admin.heading.variable-charges'"></h4>
                <div *ngIf="isEditMode">
                <div class="row">
                   <div class="data-filter">
                    <div class="col-xs-6">
                        <label [i18n]="'df-management.df-admin.form.variable-charge-name'"></label>
                        <input type="text" class="form-control"  formControlName="variableChargeName"
                        [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.variable-charge-name'}]">
                    </div>
                    <div class="col-xs-6">
                        <label [i18n]="'df-management.df-admin.form.description'"></label>
                        <input type="text" class="form-control"  formControlName="description"
                        [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.description'}]">
                    </div>
                   </div>
                </div><br>

                <div class="chepfm--form__actions" style="justify-content: flex-start">
                    <button class="btn btn-i btn-primary" type="button" (click)="addVariableCharge()">
                        <span [i18n]="'df-management.df-admin.buttonss.add-button'"></span>
                   </button>
                </div><br>
                </div>

                <div  class="table-responsive">
                    <table class="table table-striped">
                        <thead class="force-text-start">
                        <tr >
                            <th class="gray-header" [i18n]="'df-management.df-admin.form.variable-charge-name'"></th>
                            <th class="gray-header" [i18n]="'df-management.df-admin.form.description'"></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of variableChargesList"> 
                                <td>{{ r.charge_code }}</td>
                                <td>{{ r.description }}</td>
                            </tr>
                        </tbody>
                        <tbody>
                        <tr *ngFor="let r of editChargesData.charge_list">
                            <td>{{ r.charge_code }}</td>
                            <td>{{ r.description }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="chepfm--form__actions">
                    <button class="btn btn-i btn-primary" type="button"  (click)="enableEditMode()" *ngIf="!isEditMode">
                        <i class="fa fa-edit"></i>&nbsp;
                        <span [i18n]="'df-management.df-admin.buttonss.edit-button'"></span>
                    </button>
                    <button class="btn btn-i btn-primary" type="submit"  appDebounceClick (debounceClick)="dfVariableChargesData()"
                    *ngIf="isSubmitButtonEnabled()">
                      <span [i18n]="'df-management.df-admin.buttonss.submit-button'"></span>
                    </button>
                   
                  </div>
            </form>
        </div>
    </div>
</div> 

<div class="overlay" *ngIf="isPopupModel">
    <div class="sucess-popup">
        <i class="fa fa-check-circle success-button"></i>
        <h4 class="alignment" [i18n]="'df-management.form.model-popup.heading'"></h4>
      <div class="content alignment">
        <span  [i18n]="'df-management.df-admin.popupModal.charge-content'"></span>
    </div>
    <div class="form-group">
    <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="confirmData()"  *ngIf="isEditMode">
        <span [i18n]="'df-management.form.model-popup.button'"></span>
    </button>
    </div>
    </div>
</div>